// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__Ld7xu","card":"cards_card__x8bKY"};